import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { NbToastrService } from '@nebular/theme';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private toastrService: NbToastrService,
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        // Get error message
        let errorMessage = 'An error occurred. Please try again later.';
        
        if (error.error instanceof ErrorEvent) {
          // Client-side error
          errorMessage = error.error.message;
        } else {
          // Server-side error
          errorMessage = error.error?.message || errorMessage;
        }

        // Show error message for all errors
        this.toastrService.danger(errorMessage, 'Error');

        // Handle authentication errors (401, 403)
        if (error.status === 401 || error.status === 403) {
          // Clear all data from localStorage
          localStorage.clear();
          // Clear sessionStorage
          sessionStorage.clear();
          // Redirect to login page
          this.router.navigate(['auth/login']);
        }

        return throwError(() => error);
      }),
    );
  }
} 